


import React from 'react';
import './index.css';
import Navbar from './components/navbar.jsx';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './scenes/home';
import About from './scenes/about';
import Skills from './scenes/skills';
import Services from './scenes/services';
import Portfolio from './scenes/portfolio';
import Contact from './scenes/contact';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path='/' exact element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/skills' element={<Skills />} />
        <Route path='/services' element={<Services />} />
        <Route path='/portfolio' element={<Portfolio />} />
        <Route path='/contact' element={<Contact />} />
      </Routes>
    </Router>

  );
}

export default App;
